import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Informazioni ordine',
  sections: {
    driver_info: 'Info autista',
    order_info: 'Informazioni ordine',
    price_info: 'Informazioni prezzo',
    adjustments: 'Rettifiche',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Ritiro',
    [OrderMethod.Delivery]: 'Consegna',
    [OnSiteLocationType.RoomService]: 'Servizio in camera',
    [OnSiteLocationType.TableService]: 'Servizio al tavolo',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Numero camera',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Numero tavolo',
    },
  },
  labels: {
    wolt_support: 'Numero supporto Wolt: {{phone_number}}',
    wolt_support_text:
      "Per domande sull'ordine, l'autista o problemi, chiama Wolt. È importante specificare che è un ordine <strong>Wolt Drive</strong>",
    dummy_order: 'Ordine di prova',
    asap: 'ASAP',
    driver_name: 'Nome autista',
    driver_phone_number: 'Telefono autista',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN consegna',
    original: 'Originale',
    delivery_fee: 'Costo consegna',
    tip: 'Mancia',
    service_fee: 'Elaborazione online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Commissione PayPal',
    },
    promo_applied: {
      default: 'Promo applicata',
      [CouponType.Reward]: 'Punti fedeltà applicati',
      [CouponType.Cashback]: 'Punti fedeltà applicati',
      [CouponType.PromoCode]: 'Promo applicata',
      [CouponType.GiftCard]: 'Gift card applicata',
    },
    tax: 'Tasse',
    total: 'Totale',
    online_payment: "Il cliente ha già pagato nell'app {{provider}}",
    cash_payment: 'Pagamento in loco',
    invoice_payment: 'Pagamento tramite fattura',
    old_order: 'Questo ordine è stato completato con successo',
    pickup_time: 'Orario ritiro',
    pickup_asap: 'Il cliente ha richiesto il ritiro il prima possibile.',
    points_used: 'Questo ordine include un premio in punti fedeltà riscattato da un cliente fedele',
    order_note: 'Nota ordine:',
    today: 'oggi',
  },
  schedule: {
    header: 'Programmato per {{date}}, {{time}}',
    text: "Ti avviseremo quando sarà il momento di iniziare a preparare l'ordine",
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Richiesto dal cliente',
    [RefundReason.Reclamation]: 'Reclamo',
    [RefundReason.CommunicationError]: 'Errore di comunicazione',
    [RefundReason.Other]: 'Altro',
    [RefundReason.Dispute]: 'Contestazione cliente',
    dispute_win: 'Contestazione vinta',
    null: '',
  },
  toasts: {
    print_one: 'Stampa di {{count}} scontrino: Ordine <strong>#{{orderNumber}}</strong>...',
    print_other: 'Stampa di {{count}} scontrini: Ordine <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Rimborso riuscito: Ordine <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Stampa',
    confirm: 'Conferma',
    reject: 'Rifiuta',
    refund: 'Rimborso',
  },
};
